import { Box, Typography, Chip } from '@mui/material';
import { HealthAndSafety } from '@mui/icons-material';

interface OHSRecord {
  id?: string;
  referenceNumber?: string;
  type?: string;
  incidentDate?: string;
  severity?: string;
  status?: string;
  dolReported?: boolean;
  [key: string]: unknown;
}

interface EmployeeOHSProps {
  records: OHSRecord[];
}

export const EmployeeOHS = ({ records }: EmployeeOHSProps) => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <HealthAndSafety color="primary" />
      <Typography variant="subtitle1" fontWeight={700}>OHS Incidents</Typography>
      <Chip label={`${records.length} records`} size="small" sx={{ ml: 1 }} />
    </Box>
    {records.length > 0 ? (
      <Box component="table" sx={{ width: '100%' }}>
        <Box component="thead">
          <Box component="tr">
            <Box component="td">Reference #</Box>
            <Box component="td">Type</Box>
            <Box component="td">Incident Date</Box>
            <Box component="td">Severity</Box>
            <Box component="td">Status</Box>
            <Box component="td">DOL Reported</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {records.map(o => (
            <Box component="tr" key={o.id}>
              <Box component="td"><Chip label={o.referenceNumber} size="small" /></Box>
              <Box component="td">{o.type}</Box>
              <Box component="td">{o.incidentDate}</Box>
              <Box component="td"><Chip label={o.severity} size="small" color={o.severity === 'Major' ? 'error' : 'warning'} /></Box>
              <Box component="td"><Chip label={o.status} size="small" /></Box>
              <Box component="td">{o.dolReported ? 'Yes' : 'No'}</Box>
            </Box>
          ))}
        </Box>
      </Box>
    ) : (
      <Typography variant="body2" color="text.secondary">No OHS incidents found</Typography>
    )}
  </Box>
);
